/**
 * Privacy policy linked from the job-ad privacy notice for UK companies
 * (uk, controlsolutions, eco2solar) instead of the app's own recruiting page.
 */
export const EON_UK_PRIVACY_POLICY_URL =
  "https://www.eonenergy.com/privacy.html";
